import React, { useEffect } from "react";
import Footer from "../../components/footer/Footer";
import Navbar from "../../components/navbar/Navbar";
import "./aboutUs.css";
import { useLocation } from "react-router-dom";
import { useAnimation, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FaWhatsapp } from "react-icons/fa";
import ToTopBtn from "../../components/toTopBtn/ToTopBtn";

// import { useLocation } from "react-router-dom";

const squareVariantsX = {
  visible: { opacity: 1, y: 0, transition: { duration: 2 } },
  hidden: { opacity: 0, y: 100 },
};

const AboutUs = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const controls = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);
  return (
    <div className="maxWidthStyle ">
      <Navbar />
      <div>
        {/* <a
          aria-label="Chat on WhatsApp"
          href="https://wa.me/2347030916267"
          style={{ textDecoration: "none", cursor: "pointer" }}
          target="_blank"
        >
          <div className="whatsappStickbody">
            <div className="whatsappStickActive"></div>
            <FaWhatsapp />
          </div>
        </a> */}
        <ToTopBtn />
        <motion.div
          ref={ref}
          animate={controls}
          initial="hidden"
          variants={squareVariantsX}
        >
          <div className="aboutUs-heading-text">
            About Triumphant Jumak Schools
          </div>
          <div className="aboutUs-heading-body">
            <p>
              At Triumphant Jumak Schools, we are committed to nurturing young
              minds and shaping tomorrow's leaders through excellence in
              education. Established with a passion for holistic child
              development, we have grown to become a trusted institution that
              combines academic rigor with character building, preparing our
              students for success in an ever-evolving world.
            </p>
          </div>
        </motion.div>
        <div className="aboutUs-MissionText">
          <div className="aboutUs-MissionEach">
            <div className="aboutUs-MissionEachHead">
              <h3>Our Mission</h3>
            </div>
            <div className="aboutUs-MissionEachBody">
              <p>
                To provide a dynamic and functional education to pupils/student
                with the main purpose of solving everyday problem. Give the
                child leadership opportunity and roles to be a change agent.
              </p>
            </div>
          </div>

          <div className="aboutUs-MissionEach">
            <div className="aboutUs-MissionEachHead">
              <h3>Our Vision</h3>
            </div>
            <div className="aboutUs-MissionEachBody">
              <p>
                To raise a crop of children that will be morally, physically,
                and academically good and acceptable anywhere they go; and
                compete favourable in all aspects of child development with
                children from other school in Nigeria and beyond.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
